/* eslint-disable @typescript-eslint/indent */
import styled from 'styled-components';

import { colors } from '../../../styles/theme';

const mapColor = {
  accent: 'accent.base',
  default: 'default.base',
  black: 'black.base',
  black90: 'black.90',
  black80: 'black.80',
  black70: 'black.70',
  black50: 'black.50',
  black24: 'black.24',
  primary: 'primary.base',
  red: 'red.base',
  white: 'white.base',
};

interface Props {
  align?: 'inherit' | 'left' | 'center' | 'right' | 'justify';
  color?:
    | 'default'
    | 'primary'
    | 'accent'
    | 'black'
    | 'black90'
    | 'black80'
    | 'black70'
    | 'black50'
    | 'black24'
    | 'red'
    | 'white';
  readonly fontWeight?: number | string;
  readonly marginBottom?: number;
  readonly fontSize?: number;
  readonly lineHeight?: string;
  readonly gridAread?: string;
}

const TitleStyles = styled.h1<Props>`
  text-align: ${({ align }: Props) => align || 'inherit'};
  font-family: Infra;
  font-style: normal;
  font-weight: ${({ fontWeight }: Props)=> fontWeight || 500};
  font-size: ${({ fontSize }: Props) => fontSize ? `${fontSize}px` :'21px'};
  line-height: ${({ lineHeight }: Props) => lineHeight || '30px'};
  color: ${({ color = 'black' }: Props) => colors(mapColor[color!])};
  grid-area: ${({ gridAread }: Props) => gridAread || 'Title'};
  margin-bottom: ${({ marginBottom }: Props) => (marginBottom ? `${marginBottom}px` : '0')};
`;

export default TitleStyles;
